const setCookie=function(name, value){
    document.cookie = name + "=" + escape(value);
};
const getCookie=function(name){
    let arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)){
        return unescape(arr[2]);
    }else{
        return null;
    }
};
const deleteCookie=function(name){
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = getCookie(name);
    if(cval != null){
        document.cookie= name + "="+cval+";expires="+exp.toGMTString();
    }
};
export { setCookie, getCookie, deleteCookie }



// WEBPACK FOOTER //
// ./src/services/cookieFunction.js